<template>
  <InformationBox
    v-if="!defaultMessagePlacement && nodeRef?.context?.state?.invalid"
    :title="errorTitle"
    :description="errorMessage"
    :type="InformationBoxTypes.ERROR"
  />
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';
import InformationBox from '@/components/InformationBox/InformationBox.vue';
import { InformationBoxTypes } from '@/interfaces/forms/information-box.interface';

const props = defineProps<{
  node: any;
  errorTitle?: string;
  errorMessage?: string;
  defaultMessagePlacement?: boolean;
}>();

const nodeRef = computed(() => props.node);

watch(
  () => props.defaultMessagePlacement,
  () => {
    if (nodeRef.value?.context) {
      nodeRef.value.context.defaultMessagePlacement = props.defaultMessagePlacement;
    }
  }
);
</script>
